import {
  CREATE_INTEGRATION,
  CREATE_INTEGRATION_SUCCESS,
  CREATE_INTEGRATION_ERROR,
  GET_INTEGRATIONS,
  GET_INTEGRATIONS_SUCCESS,
  GET_INTEGRATIONS_ERROR,
  UPDATE_INTEGRATION,
  UPDATE_INTEGRATION_SUCCESS,
  UPDATE_INTEGRATION_ERROR,
  DELETE_INTEGRATION,
  DELETE_INTEGRATION_SUCCESS,
  DELETE_INTEGRATION_ERROR,
  TEST_INTEGRATION,
  TEST_INTEGRATION_SUCCESS,
  TEST_INTEGRATION_ERROR,
  GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE,
  GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_SUCCESS,
  GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_ERROR,
  GET_INTEGRATION_TEMPLATES,
  GET_INTEGRATION_TEMPLATES_SUCCESS,
  GET_INTEGRATION_TEMPLATES_ERROR,
  DUPLICATE_INTEGRATIONS,
  DUPLICATE_INTEGRATIONS_SUCCESS,
  DUPLICATE_INTEGRATIONS_ERROR,
  GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES,
  GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_SUCCESS,
  GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_ERROR,
  GET_LEAD_INTEGRATION_LOGS_BY_ID,
  GET_LEAD_INTEGRATION_LOGS_BY_ID_SUCCESS,
  GET_LEAD_INTEGRATION_LOGS_BY_ID_ERROR,
  EXPORT_LEAD_INTEGRATION_LOGS,
  EXPORT_LEAD_INTEGRATION_LOGS_SUCCESS,
  EXPORT_LEAD_INTEGRATION_LOGS_ERROR,
  GET_CAMPAIGNS_BY_INTEGRATION,
  GET_CAMPAIGNS_BY_INTEGRATION_SUCCESS,
  GET_CAMPAIGNS_BY_INTEGRATION_ERROR,
  GET_INTEGRATIONS_STATS_BY_DATES,
  GET_INTEGRATIONS_STATS_BY_DATES_SUCCESS,
  GET_INTEGRATIONS_STATS_BY_DATES_ERROR,
  GET_INTEGRATIONS_FAILURE_REASON_STATS,
  GET_INTEGRATIONS_FAILURE_REASON_STATS_SUCCESS,
  GET_INTEGRATIONS_FAILURE_REASON_STATS_ERROR,
  GET_INTEGRATIONS_STATS,
  GET_INTEGRATIONS_STATS_SUCCESS,
  GET_INTEGRATIONS_STATS_ERROR,
  GET_RESPONSE_PARSER_FUNCTIONS_SUCCESS,
  GET_RESPONSE_PARSER_FUNCTIONS_ERROR,
  GET_RESPONSE_PARSER_FUNCTIONS,
  GET_INTERMEDIATE_LEAD_INTEGRATIONS,
  GET_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS,
  GET_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR,
  UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS,
  UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS,
  UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR,
  GET_INTEGRATION_SAMPLE_LEADS,
  GET_INTEGRATION_SAMPLE_LEADS_SUCCESS,
  GET_INTEGRATION_SAMPLE_LEADS_ERROR
} from "./actionTypes"
import {
  handleGetLeadIntegrationLogsById,
  handleGetLeadIntegrationLogsByIdError,
  handleGetLeadIntegrationLogsByIdSuccess,
} from "helpers/lead_integration_logs_helper"

const initialState = {
  integrations: [],
  error: null,
  loading: false,
  sf_lead_integration_macros: [],
  test_integration: false,
  test_integration_loading: false,
  lead_integration_logs: [],
  lead_integration_logs_loading: false,
  lead_integration_default_payload_value: null,
  lead_integration_default_payload_value_error: null,
  lead_integration_default_payload_value_loading: null,
  lead_integration_templates: [],
  lead_integration_templates_loading: false,
  sf_lead_integration_macro_categories: [],
  sf_lead_integration_flattened_macro_categories: [],
  sf_lead_integration_macro_categories_error: null,
  sf_lead_integration_macro_categories_loading: false,
  lead_integration_logs_by_id: [],
  lead_integration_logs_by_id_loading: false,
  lead_integration_logs_by_id_error: null,
  lead_integration_logs_export_loading: false,
  lead_integration_logs_export_error: null,
  lead_integration_logs_by_id_last_page_fetched: 0,
  lead_integration_logs_total_number_of_pages: 0,
  lead_integration_logs_has_lookahead_pages: false,
  lead_integration_logs_active_cache_key: null,
  lead_integration_logs_page_cache: {},
  campaigns_by_integration: [],
  campaigns_by_integration_loading: false,
  campaigns_by_integration_error: null,
  integration_stats_by_dates: [],
  integration_failure_reason_stats: [],
  lead_integration_stats: [],
  lead_integration_stats_loading: false,
  integration_failure_reason_stats_loading: false,
  response_parser_functions: [],
  response_parser_functions_loading: false,
  response_parser_functions_error: null,
  intermediate_integrations: [],
  intermediate_integrations_loading: false,
  intermediate_integrations_error: null,
  integration_sample_leads: [],
  integration_sample_leads_loading: false,
  integration_sample_leads_error: true,
  has_next_page: false,
}

const Integration = (state = initialState, action) => {
  switch (action.type) {
    case GET_INTEGRATIONS:
      return {
        ...state,
        loading: true
      }

    case GET_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        integrations: action.payload,
        loading: false
      }

    case GET_INTEGRATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_INTERMEDIATE_LEAD_INTEGRATIONS:
      return {
        ...state,
        intermediate_integrations_loading: true
      }

    case GET_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        intermediate_integrations: action.payload,
        intermediate_integrations_loading: false
      }

    case GET_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR:
      return {
        ...state,
        intermediate_integrations_error: action.payload,
        intermediate_integrations_loading: false
      }

    case UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS:
      return {
        ...state,
        intermediate_integrations_loading: true
      }

    case UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        intermediate_integrations: action.payload,
        intermediate_integrations_loading: false
      }

    case UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR:
      return {
        ...state,
        intermediate_integrations_error: action.payload,
        intermediate_integrations_loading: false
      }

    case GET_RESPONSE_PARSER_FUNCTIONS:
      return {
        ...state,
        response_parser_functions_loading: true
      }

    case GET_RESPONSE_PARSER_FUNCTIONS_SUCCESS:
      return {
        ...state,
        response_parser_functions: action.payload,
        response_parser_functions_loading: false
      }

    case GET_RESPONSE_PARSER_FUNCTIONS_ERROR:
      return {
        ...state,
        response_parser_functions_error: action.payload,
        response_parser_functions_loading: false
      }

    case GET_INTEGRATIONS_STATS_BY_DATES:
      return {
        ...state,
        loading: true
      }

    case GET_INTEGRATIONS_STATS_BY_DATES_SUCCESS:
      return {
        ...state,
        integration_stats_by_dates: action.payload,
        loading: false
      }

    case GET_INTEGRATIONS_STATS_BY_DATES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_INTEGRATIONS_FAILURE_REASON_STATS:
      return {
        ...state,
        integration_failure_reason_stats_loading: true
      }

    case GET_INTEGRATIONS_FAILURE_REASON_STATS_SUCCESS:
      return {
        ...state,
        integration_failure_reason_stats: action.payload,
        integration_failure_reason_stats_loading: false
      }
    case GET_INTEGRATIONS_FAILURE_REASON_STATS_ERROR:
      return {
        ...state,
        error: action.payload,
        integration_failure_reason_stats_loading: false
      }

    case GET_INTEGRATIONS_STATS:
      return {
        ...state,
        lead_integration_stats_loading: true
      }

    case GET_INTEGRATIONS_STATS_SUCCESS:
      return {
        ...state,
        lead_integration_stats: action.payload,
        lead_integration_stats_loading: false
      }

    case GET_INTEGRATIONS_STATS_ERROR:
      return {
        ...state,
        error: action.payload,
        lead_integration_stats_loading: false
      }

    case GET_INTEGRATION_TEMPLATES:
      return {
        ...state,
        lead_integration_templates_loading: true
      }

    case GET_INTEGRATION_TEMPLATES_SUCCESS:
      return {
        ...state,
        lead_integration_templates: action.payload,
        lead_integration_templates_loading: false
      }

    case GET_INTEGRATION_TEMPLATES_ERROR:
      return {
        ...state,
        error: action.payload,
        lead_integration_templates_loading: false
      }

    case DUPLICATE_INTEGRATIONS:
      return {
        ...state,
        error: null,
        loading: true
      }

    case DUPLICATE_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        integrations: [...state.integrations, ...action.payload]
      }

    case DUPLICATE_INTEGRATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_INTEGRATION:
      return {
        ...state,
        error: null,
        loading: action?.loading
      }

    case UPDATE_INTEGRATION_SUCCESS:
      // Since we have another option to create template from update
      // We have to consider new integrations coming in which are not in the reducer
      {
        const integration_ids_from_payload = (action.payload || []).map(li => li.id);
        // Exclude the integrations coming from payload
        // since they either have to be replaced or added
        const previous_state_integrations_wo_payload = state.integrations.filter(li => !integration_ids_from_payload.includes(li.id))

        return {
          ...state,
          integrations: [...previous_state_integrations_wo_payload, ...action.payload],
          error: null,
          loading: false
        }
      }

    case UPDATE_INTEGRATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case CREATE_INTEGRATION:
      return {
        ...state,
        error: null,
        loading: true
      }

    case CREATE_INTEGRATION_SUCCESS:
      return {
        ...state,
        integrations: [...state.integrations, ...action.payload],
        error: null,
        loading: false
      }

    case CREATE_INTEGRATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_INTEGRATION:
      return {
        ...state,
        error: null,
        loading: true
      }

    case DELETE_INTEGRATION_SUCCESS:
      return {
        ...state,
        integrations: state.integrations.filter(e => !(action.payload.map(each => each.id).includes(e.id))),
        error: null,
        loading: false
      }

    case DELETE_INTEGRATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case TEST_INTEGRATION:
      return {
        ...state,
        test_integration_loading: true,
        lead_integration_logs_loading: true
      }

    case TEST_INTEGRATION_SUCCESS:
      return {
        ...state,
        lead_integration_logs: [
          ...state.lead_integration_logs,
          action.payload
        ],
        test_integration_loading: false,
        lead_integration_logs_loading: false,
      }

    case TEST_INTEGRATION_ERROR:
      return {
        ...state,
        test_integration_loading: false,
        test_integration_error: action.payload,
        lead_integration_logs_loading: false,
      }

    case GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE:
      return {
        ...state,
        lead_integration_default_payload_value_loading: true
      }

    case GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_SUCCESS:
      return {
        ...state,
        lead_integration_default_payload_value: action.payload,
        lead_integration_default_payload_value_loading: false,
      }

    case GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_ERROR:
      return {
        ...state,
        lead_integration_default_payload_value_loading: false,
        lead_integration_default_payload_value_error: action.payload
      }

    case GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES:
      return {
        ...state,
        sf_lead_integration_macro_categories_loading: true
      }

    case GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_SUCCESS:
      {
        const recursive_flatten_sf_macros = (categories) => {
          let flattened_macros = []
          categories.forEach(category => {
            if (category?.sf_lead_integration_macros) {
              flattened_macros = [...flattened_macros, ...category?.sf_lead_integration_macros]
            }
            if (category?.sub_categories) {
              flattened_macros = [...flattened_macros, ...recursive_flatten_sf_macros(category?.sub_categories)]
            }
          })
          return flattened_macros
        }

        const flattened_macros = recursive_flatten_sf_macros(action.payload)

        return {
          ...state,
          sf_lead_integration_macro_categories: action.payload,
          sf_lead_integration_macros: flattened_macros,
          sf_lead_integration_macro_categories_loading: false,
        }
      }

    case GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_ERROR:
      return {
        ...state,
        sf_lead_integration_macro_categories_loading: false,
        sf_lead_integration_macro_categories_error: action.payload
      }

    case GET_LEAD_INTEGRATION_LOGS_BY_ID:
      return handleGetLeadIntegrationLogsById(state, action)

    case GET_LEAD_INTEGRATION_LOGS_BY_ID_SUCCESS:
      return handleGetLeadIntegrationLogsByIdSuccess(state, action)

    case GET_LEAD_INTEGRATION_LOGS_BY_ID_ERROR:
      return handleGetLeadIntegrationLogsByIdError(state, action)

    case EXPORT_LEAD_INTEGRATION_LOGS:
      return {
        ...state,
        lead_integration_logs_export_loading: true,
        lead_integration_logs_export_error: null,
      }

    case EXPORT_LEAD_INTEGRATION_LOGS_SUCCESS:
      return {
        ...state,
        lead_integration_logs_export_loading: false,
      }

    case EXPORT_LEAD_INTEGRATION_LOGS_ERROR:
      return {
        ...state,
        lead_integration_logs_export_loading: false,
        lead_integration_logs_export_error: action.payload,
      }

    case GET_CAMPAIGNS_BY_INTEGRATION:
      return {
        ...state,
        campaigns_by_integration_loading: true
      }

    case GET_CAMPAIGNS_BY_INTEGRATION_SUCCESS:
      return {
        ...state,
        campaigns_by_integration: action.payload,
        campaigns_by_integration_loading: false
      }

    case GET_CAMPAIGNS_BY_INTEGRATION_ERROR:
      return {
        ...state,
        campaigns_by_integration_error: action.payload,
        campaigns_by_integration_loading: false
      }

    case GET_INTEGRATION_SAMPLE_LEADS:
      return {
        ...state,
        integration_sample_leads_loading: true,
      }

    case GET_INTEGRATION_SAMPLE_LEADS_SUCCESS:
      return {
        ...state,
        integration_sample_leads: action.payload,
        integration_sample_leads_loading: false,
      }

    case GET_INTEGRATION_SAMPLE_LEADS_ERROR:
      return {
        ...state,
        integration_sample_leads_error: action.payload,
        integration_sample_leads_loading: false,
      }

    default:
      return state
  }
}

export default Integration
